import { EmptyStateProcessIllustration, Button, ExternalLink } from "@octopusdeploy/design-system-components";
import type { GitRef } from "@octopusdeploy/octopus-server-client";
import { links } from "@octopusdeploy/portal-routes";
import ActionList from "~/components/ActionList/ActionList";
import OnboardingPage from "~/components/GettingStarted/OnboardingPage";
interface OnboardingProps {
    slug: string;
    gitRef: GitRef | undefined;
}
const ProcessTemplateOnboarding = ({ slug, gitRef }: OnboardingProps) => {
    const createProcessHref = links.editProcessTemplatePage.generateUrl({ slug }, { gitRef, stepTemplates: true });
    return (<OnboardingPage title="Add steps to your Process Template" intro={"Process templates are reusable, standardized blocks of steps that can be used in deployment processes or runbooks with flexibility for app teams."} learnMore={<ExternalLink href="process-templates">Learn more</ExternalLink>} image={<EmptyStateProcessIllustration />} actionButtons={<ActionList alignStart={true} actions={[<Button label={"Create Process"} href={createProcessHref} importance="primary"/>]}/>}/>);
};
export default ProcessTemplateOnboarding;
